import type { BackgroundCheck } from "@/types";
import { formatStatus } from "@/features/person/utils/utils";
import { calculateTimeRemaining, isBeforeToday, toFormat } from "@/lib/dateHelpers";

export function getRequirementStatusLabel(backgroundCheck?: BackgroundCheck | null): string {
  if (!backgroundCheck?.status) return "Not Started";
  return formatStatus(backgroundCheck.status, "Not Started") ?? "Not Started";
}

export function getRequirementScreenedDate(backgroundCheck?: BackgroundCheck | null): string {
  const source = backgroundCheck?.startDate ?? backgroundCheck?.endDate;
  if (!source) return "--";
  return toFormat(source) ?? "--";
}

export function getRequirementExpirationDate(backgroundCheck?: BackgroundCheck | null): string {
  if (!backgroundCheck?.expirationDate) return "--";

  const timeRemaining = calculateTimeRemaining(backgroundCheck.expirationDate);
  if (timeRemaining) return timeRemaining;

  if (isBeforeToday(backgroundCheck.expirationDate)) {
    return `Expired: ${toFormat(backgroundCheck.expirationDate) ?? "--"}`;
  }

  return toFormat(backgroundCheck.expirationDate) ?? "--";
}

export function isRequirementApproved(backgroundCheck?: BackgroundCheck | null): boolean {
  return backgroundCheck?.status?.toUpperCase() === "APPROVED";
}

export const REQUIREMENT_MANAGEMENT_TOOLTIP = {
  title: "Requirement status",
  supportingText:
    "Official qualifying level background check status in the membership record. HireRight activity is tracked separately in Screening Orders."
} as const;
